export const cardSection1BreakpointConfig = {
  xsmall: {
    // when not overlaid, direction
    contentAlignment: {
      horizontal: 'middle',
      vertical: 'bottom', // if middle then verticalOffsetType is invalid
    },
    gridSetup: {
      image: {
        columns: 16,
      },
      content: {
        columns: 16,
      },
      card: {
        columns: 16,
      },
    },
  },
  medium: {
    gridSetup: {
      card: {
        columns: 'one-third-width-cell', // TODO do we need some centering too? justify-content: center;
      },
    },
  },
};

export const cardSection2BreakpointConfig = {
  xsmall: {
    // when not overlaid, direction
    contentAlignment: {
      horizontal: 'middle',
      vertical: 'bottom', // if middle then verticalOffsetType is invalid
    },
    gridSetup: {
      image: {
        columns: 16,
      },
      content: {
        columns: 16,
      },
      card: {
        columns: 16,
      },
    },
  },
  medium: {
    gridSetup: {
      card: {
        columns: 8, // TODO do we need some centering too? justify-content: center;
      },
    },
  },
};
